(function () {
  'use strict';

  const SELECTOR = '.faq-footer__outer[data-faq-footer]';
  const BASE_HEIGHT = 1042;
  const DESKTOP_MIN = 768;
  const FAQ_LIST_TOP = 182.773;
  const DOCS_HEADING_BASE_TOP = 536;
  const GAP_FAQ_TO_DOCS = DOCS_HEADING_BASE_TOP - (FAQ_LIST_TOP + 299);
  const FOOTER_BASE_TOP = 937;
  const DOCS_BLOCK_HEIGHT = 210;
  const FOOTER_GAP = FOOTER_BASE_TOP - (DOCS_HEADING_BASE_TOP + DOCS_BLOCK_HEIGHT);
  const FOOTER_HEIGHT = 40.5;
  const BOTTOM_PAD = 64.5;

  function getStageScale() {
    const raw = getComputedStyle(document.documentElement)
      .getPropertyValue('--desktop-stage-scale')
      .trim();
    const scale = parseFloat(raw);
    if (Number.isFinite(scale) && scale > 0) {
      return scale;
    }
    return 1;
  }

  function updateExpandedLayout(root) {
    if (window.innerWidth < DESKTOP_MIN) {
      return;
    }

    const viewport = root.querySelector('.desktop-stage-follower__viewport');
    const canvas = root.querySelector('[data-faq-footer-canvas]');
    const faqList = root.querySelector('[data-faq-footer-list]');
    const documents = root.querySelector('[data-faq-footer-documents]');
    const footer = root.querySelector('.faq-footer__footer');
    if (!viewport || !canvas || !faqList || !footer) {
      return;
    }

    const baseHeight =
      parseInt(root.getAttribute('data-desktop-stage-height'), 10) || BASE_HEIGHT;
    const scale = getStageScale();
    const faqListHeight = faqList.offsetHeight;
    const faqListBottom = FAQ_LIST_TOP + faqListHeight;
    const docsTop = Math.max(DOCS_HEADING_BASE_TOP, faqListBottom + GAP_FAQ_TO_DOCS);

    if (documents instanceof HTMLElement) {
      documents.style.top = docsTop + 'px';
    }

    const docsHeight = documents instanceof HTMLElement ? documents.offsetHeight : 0;
    const contentBottom = docsTop + docsHeight;
    const footerTop = Math.max(FOOTER_BASE_TOP, contentBottom + FOOTER_GAP);
    const canvasHeight = Math.max(baseHeight, footerTop + FOOTER_HEIGHT + BOTTOM_PAD);

    footer.style.top = footerTop + 'px';
    canvas.style.height = canvasHeight + 'px';
    viewport.style.height = canvasHeight * scale + 'px';

    if (canvasHeight > baseHeight + 1) {
      root.setAttribute('data-desktop-stage-expanded-height', String(canvasHeight));
      root.classList.add('faq-footer__outer--expanded');
    } else {
      root.removeAttribute('data-desktop-stage-expanded-height');
      root.classList.remove('faq-footer__outer--expanded');
    }
  }

  function scheduleLayoutUpdate(root) {
    window.requestAnimationFrame(function () {
      updateExpandedLayout(root);
    });
  }

  function closeOtherItems(root, exceptItem) {
    root.querySelectorAll('[data-faq-item].is-open').forEach(function (openItem) {
      if (openItem === exceptItem) {
        return;
      }

      openItem.classList.remove('is-open');
      const openTrigger = openItem.querySelector('[data-faq-trigger]');
      const openPanelId = openTrigger?.getAttribute('aria-controls');
      const openPanel = openPanelId ? document.getElementById(openPanelId) : null;

      if (openTrigger) {
        openTrigger.setAttribute('aria-expanded', 'false');
      }
      if (openPanel) {
        openPanel.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function toggleItem(trigger, root) {
    const item = trigger.closest('[data-faq-item]');
    if (!item || !root.contains(item)) {
      return;
    }

    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    const nextOpen = !isOpen;

    if (nextOpen) {
      closeOtherItems(root, item);
    }

    trigger.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
    item.classList.toggle('is-open', nextOpen);

    if (panel) {
      panel.setAttribute('aria-hidden', nextOpen ? 'false' : 'true');
    }

    scheduleLayoutUpdate(root);
  }

  function bindRoot(root) {
    if (!(root instanceof HTMLElement)) {
      return;
    }
    if (root.dataset.faqFooterBound === 'true') {
      scheduleLayoutUpdate(root);
      return;
    }
    root.dataset.faqFooterBound = 'true';

    root.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-faq-trigger]');
      if (!trigger || !root.contains(trigger)) {
        return;
      }
      toggleItem(trigger, root);
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }
      const trigger = event.target.closest('[data-faq-trigger]');
      if (!trigger || !root.contains(trigger)) {
        return;
      }
      event.preventDefault();
      toggleItem(trigger, root);
    });

    scheduleLayoutUpdate(root);
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function () {
    document.querySelectorAll(SELECTOR).forEach(scheduleLayoutUpdate);
  });

  window.addEventListener('resize', function () {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        document.querySelectorAll(SELECTOR).forEach(scheduleLayoutUpdate);
      });
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target;
    if (!(section instanceof HTMLElement)) {
      return;
    }
    const root = section.matches(SELECTOR) ? section : section.querySelector(SELECTOR);
    if (root instanceof HTMLElement) {
      bindRoot(root);
    }
  });
})();
